import { mapGetters } from 'vuex';

export default {
    name: 'agentWorkflow',
    inject: ['$eventBus'],
    props: {
        hotleadType: {
            type: String,
            default: 'PopupHotleadInAgentProfilePage_seller'
        }
    },
    computed:{
        ...mapGetters('glb', ['glb'])
    },
    data() {
        return {
            isBuyer: true
        };
    },
    methods: {
        switchBuyer(flag){
            this.isBuyer = flag;
        },
        openHotlead() {
            this.$eventBus.$emit('dialog-center', {
                name: 'mvtHotleadForm',
                trigger: this.$options.name,
                opt: {
                    hotleadSup: 'GET STARTED',
                    hotleadTitle: 'Connect with an agent',
                    hotleadType: this.hotleadType,
                    buttonText: 'Get Started',
                    showGeo: true,
                    profileUrl: this.glb.cdnUrl + 'vimages/assignedAgent.jpg',
                },
            });
        }
    }
};